import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import MobilityOptionsAddOptionModal from '../../components/mobility-options/MobilityOptionsAddOptionModal'
import { createMobilityOption } from '../../state/actions/mobility-options'
import { IMobilityOptionObject, IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    categories: Object.values(state.mobilityOptionsCategories.items),
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onCreateClick: (mobilityOption: IMobilityOptionObject) => {
      return dispatch(createMobilityOption(mobilityOption))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobilityOptionsAddOptionModal)



// WEBPACK FOOTER //
// ./src/containers/mobility-options/MobilityOptionsAddOptionModal.ts